import { useQuery } from '@tanstack/react-query';

import { withGlobalError } from '@/react-tools/react-query';
import { AutoPatch } from '@/react/portainer/settings/types';
import axios, { parseAxiosError } from 'Portainer/services/axios';

import { buildUrl } from './autoPatch.service';
import { queryKeys } from './queryKeys';

export function useAutoPatches() {
  return useQuery(queryKeys.base(), getAutoPatches, {
    staleTime: 50,
    ...withGlobalError('Unable to retrieve patch history'),
  });
}

async function getAutoPatches() {
  try {
    const { data } = await axios.get<{ autoUpdates: AutoPatch[] }>(buildUrl());
    return data;
  } catch (e) {
    throw parseAxiosError(e as Error, 'Unable to retrieve patch history');
  }
}
